define.alias("shared/components/shared/locale", "media/components/shared/locale");